import _ from 'underscore';
import PerformanceMetricsColumns from '../common-columns/performance-metrics-columns';
import SOVColumns from '../common-columns/sov-columns';

export function getColumnsMetadata() {
  return _.defaults({
    AdPreview: 'Title',
    AdGroup: 'AdGroup/Name',
    Campaign: 'Campaign/Name',
    Delivery: 'DeliveryStatus',
    AdID: 'Id',
    AdType: 'Type',
  }, PerformanceMetricsColumns, SOVColumns);
}
